export const extractProductsFromPackages = (packages = []) => {
  return packages
    ?.map((pack) => pack.products.map((prod) => ({ id: prod.id, sales_count: prod.quantity })))
    ?.flat();
};

export const extractCheckedProducts = (products = []) => {
  return products?.map(({ id, sales_count }) => ({
    id,
    sales_count
  }));
};

export const extractProceduresFromPackages = (packages = []) => {
  return packages?.map((pack) => pack?.procedures?.map(({ id }) => id))?.flat();
};

export const extractCheckedProcedures = (services = []) => {
  return services?.map(({ id }) => id);
};
